import React, { useEffect, useState } from 'react';
import { obtenerServiciosPublicos, obtenerNegocioPublicoPorSlug } from '../services/serviciosService';
import { etiquetaPrecio, etiquetaDuracion, MODALIDADES_SERVICIO } from '../utils/servicios';
import { linkWhatsAppA } from '../utils/compartir';

// Página PÚBLICA del catálogo de servicios (la abre el cliente sin cuenta).
// Mobile-first, con la marca del negocio. Cada servicio se puede TOCAR para ver
// una ficha detallada (fotos, incluye/no incluye, requisitos…). "Me interesa"
// abre WhatsApp con el negocio, con el detalle del servicio (código + precio +
// enlace directo a la ficha) para que el negocio sepa exactamente cuál es.

function fotosDe(s) {
  return [1, 2, 3, 4, 5].map((n) => s[`foto_${n}_url`]).filter(Boolean);
}
function modalidadServicio(clave) {
  return (MODALIDADES_SERVICIO.find((m) => m.clave === clave) || {});
}

export default function CatalogoServiciosPublico({ slug }) {
  const [negocio, setNegocio] = useState(null);
  const [servicios, setServicios] = useState([]);
  const [estado, setEstado] = useState('cargando');
  const [detalle, setDetalle] = useState(null); // servicio abierto en ficha

  useEffect(() => {
    let activo = true;
    (async () => {
      try {
        const n = await obtenerNegocioPublicoPorSlug(slug);
        if (!activo) return;
        if (!n?.id) { setEstado('noencontrado'); return; }
        setNegocio(n);
        const servs = await obtenerServiciosPublicos(n.id);
        setServicios(servs);
        // ?s=<codigo> → abre directo esa ficha (enlace que el negocio recibe).
        const ref = new URLSearchParams(window.location.search).get('s');
        if (ref) {
          const s = servs.find((x) => x.codigo === ref || x.id === ref);
          if (s) setDetalle(s);
        }
        setEstado('ok');
      } catch { if (activo) setEstado('noencontrado'); }
    })();
    return () => { activo = false; };
  }, [slug]);

  const acento = negocio?.color_principal || '#DB2777';
  const moneda = negocio?.moneda || 'L';

  const mensajeInteres = (s) => {
    const link = `${window.location.origin}/servicios/${slug}?s=${encodeURIComponent(s.codigo || s.id)}`;
    return `Hola ${negocio.nombre}! 👋 Me interesa este servicio:\n\n*${s.nombre}*${s.codigo ? ` (${s.codigo})` : ''}\nPrecio: ${etiquetaPrecio(s, moneda)}\n\n¿Me puedes dar más información?\n\n🔗 Ver: ${link}`;
  };
  const interesa = (s) => {
    const msg = mensajeInteres(s);
    const url = negocio.telefono ? linkWhatsAppA(negocio.telefono, msg) : `https://api.whatsapp.com/send?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const centro = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#EEF0F3', padding: '20px', fontFamily: 'Arial, sans-serif', textAlign: 'center' };
  if (estado === 'cargando') return <div style={centro}><p style={{ color: '#6B7280', fontWeight: 700 }}>⏳ Cargando servicios…</p></div>;
  if (estado === 'noencontrado') {
    return (
      <div style={centro}>
        <div style={{ maxWidth: '340px', color: '#4B5563' }}>
          <div style={{ fontSize: '44px' }}>🔍</div>
          <p style={{ margin: '8px 0 0', fontWeight: 700, color: '#111827' }}>No encontramos este catálogo</p>
          <p style={{ margin: '6px 0 0', fontSize: '14px' }}>Revisa el enlace, o pídele al negocio que te lo comparta de nuevo.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#EEF0F3', fontFamily: 'Arial, sans-serif', paddingBottom: '30px' }}>
      <div style={{ background: acento, color: '#fff', padding: '26px 20px 22px', textAlign: 'center' }}>
        {negocio.logo_url
          ? <img src={negocio.logo_url} alt="" style={{ width: '68px', height: '68px', borderRadius: '16px', objectFit: 'cover', background: '#fff', marginBottom: '8px' }} />
          : <div style={{ width: '68px', height: '68px', borderRadius: '16px', background: 'rgba(255,255,255,0.25)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '30px', fontWeight: 800, marginBottom: '8px' }}>{(negocio.nombre || 'K').charAt(0).toUpperCase()}</div>}
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 800 }}>{negocio.nombre}</h1>
        <p style={{ margin: '2px 0 0', fontSize: '13.5px', opacity: 0.9 }}>Nuestros servicios</p>
      </div>

      <div style={{ maxWidth: '640px', margin: '0 auto', padding: '16px 12px' }}>
        {servicios.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#6B7280', padding: '40px 16px' }}>Este negocio aún no tiene servicios publicados.</p>
        ) : (
          <div style={{ display: 'grid', gap: '14px' }}>
            {servicios.map((s) => {
              const foto = fotosDe(s)[0];
              const dur = etiquetaDuracion(s);
              return (
                <div key={s.id} onClick={() => setDetalle(s)}
                  style={{ background: '#fff', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.06)', cursor: 'pointer' }}>
                  {foto && <img src={foto} alt={s.nombre} style={{ width: '100%', height: '180px', objectFit: 'cover', display: 'block' }} />}
                  <div style={{ padding: '16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', alignItems: 'flex-start' }}>
                      <h2 style={{ margin: 0, fontSize: '17px', color: '#111827', fontWeight: 800 }}>{s.nombre}</h2>
                      {s.destacado && <span style={{ fontSize: '11px', fontWeight: 700, color: acento, whiteSpace: 'nowrap' }}>⭐ Destacado</span>}
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', margin: '6px 0 0' }}>
                      <span style={{ fontSize: '18px', fontWeight: 800, color: acento }}>{etiquetaPrecio(s, moneda)}</span>
                      {dur && <span style={{ fontSize: '12.5px', color: '#9CA3AF' }}>⏱️ {dur}</span>}
                    </div>
                    {s.descripcion_corta && <p style={{ margin: '8px 0 0', fontSize: '13.5px', color: '#4B5563', lineHeight: 1.5 }}>{s.descripcion_corta}</p>}
                    <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                      <button onClick={(e) => { e.stopPropagation(); setDetalle(s); }}
                        style={{ flex: 1, padding: '12px', borderRadius: '12px', border: `1.5px solid ${acento}`, background: '#fff', color: acento, fontSize: '14px', fontWeight: 700, cursor: 'pointer' }}>
                        Ver detalles
                      </button>
                      <button onClick={(e) => { e.stopPropagation(); interesa(s); }}
                        style={{ flex: 1, padding: '12px', borderRadius: '12px', border: 'none', background: '#25D366', color: '#fff', fontSize: '14px', fontWeight: 800, cursor: 'pointer' }}>
                        💬 Me interesa
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <p style={{ textAlign: 'center', fontSize: '11.5px', color: '#9CA3AF', margin: '20px 0 0' }}>Catálogo hecho con Kontrol · by Automatika.IA</p>
      </div>

      {detalle && (
        <FichaServicio servicio={detalle} acento={acento} moneda={moneda}
          onInteresa={() => interesa(detalle)} onCerrar={() => setDetalle(null)} />
      )}
    </div>
  );
}

// Ficha detallada de un servicio (galería de fotos + todo el detalle).
function FichaServicio({ servicio: s, acento, moneda, onInteresa, onCerrar }) {
  const fotos = fotosDe(s);
  const dur = etiquetaDuracion(s);
  const mod = modalidadServicio(s.modalidad_servicio);
  const lista = (v) => Array.isArray(v) ? v : [];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1200 }} onClick={onCerrar}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '20px 20px 0 0', width: '640px', maxWidth: '100%', maxHeight: '92vh', overflowY: 'auto', boxSizing: 'border-box' }}>
        {/* Galería */}
        <div style={{ position: 'relative' }}>
          {fotos.length > 0 ? (
            <div style={{ display: 'flex', overflowX: 'auto', scrollSnapType: 'x mandatory' }}>
              {fotos.map((f, i) => (
                <img key={i} src={f} alt="" style={{ width: '100%', flex: '0 0 100%', height: '240px', objectFit: 'cover', scrollSnapAlign: 'center', display: 'block' }} />
              ))}
            </div>
          ) : <div style={{ height: '80px', background: acento }} />}
          <button onClick={onCerrar} style={{ position: 'absolute', top: '12px', right: '12px', width: '34px', height: '34px', borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: '18px', cursor: 'pointer' }}>✕</button>
          {fotos.length > 1 && <div style={{ position: 'absolute', bottom: '10px', left: 0, right: 0, textAlign: 'center', color: '#fff', fontSize: '12px', textShadow: '0 1px 3px rgba(0,0,0,0.6)' }}>desliza para ver {fotos.length} fotos →</div>}
        </div>

        <div style={{ padding: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '20px', color: '#111827', fontWeight: 800 }}>{s.nombre}</h2>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap', margin: '8px 0 0' }}>
            <span style={{ fontSize: '22px', fontWeight: 800, color: acento }}>{etiquetaPrecio(s, moneda)}</span>
            {dur && <span style={{ fontSize: '13px', color: '#6B7280' }}>⏱️ {dur}</span>}
            {mod.nombre && <span style={{ fontSize: '13px', color: '#6B7280' }}>{mod.icono} {mod.nombre}</span>}
          </div>
          {s.cobertura && <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#6B7280' }}>📍 {s.cobertura}</p>}
          {s.descripcion && <p style={{ margin: '14px 0 0', fontSize: '14px', color: '#374151', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{s.descripcion}</p>}

          <Seccion titulo="✓ Qué incluye" items={lista(s.incluye)} color="#047857" />
          <Seccion titulo="✗ No incluye" items={lista(s.no_incluye)} color="#B91C1C" />
          <Seccion titulo="📋 Requisitos" items={lista(s.requisitos)} color="#6B7280" />
          {s.condiciones && <Bloque titulo="Condiciones" texto={s.condiciones} />}
          {s.politica_cancelacion && <Bloque titulo="Política de cancelación" texto={s.politica_cancelacion} />}

          <button onClick={onInteresa}
            style={{ width: '100%', marginTop: '20px', padding: '15px', borderRadius: '12px', border: 'none', background: '#25D366', color: '#fff', fontSize: '15px', fontWeight: 800, cursor: 'pointer' }}>
            💬 Me interesa
          </button>
        </div>
      </div>
    </div>
  );
}

function Seccion({ titulo, items, color }) {
  if (!items || items.length === 0) return null;
  return (
    <div style={{ marginTop: '16px' }}>
      <p style={{ margin: '0 0 6px', fontSize: '13.5px', fontWeight: 700, color }}>{titulo}</p>
      {items.map((it, i) => (
        <div key={i} style={{ fontSize: '13.5px', color: '#374151', marginBottom: '3px' }}>• {it}</div>
      ))}
    </div>
  );
}
function Bloque({ titulo, texto }) {
  return (
    <div style={{ marginTop: '16px' }}>
      <p style={{ margin: '0 0 4px', fontSize: '12.5px', fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.3px' }}>{titulo}</p>
      <p style={{ margin: 0, fontSize: '13.5px', color: '#374151', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{texto}</p>
    </div>
  );
}
